export const Bio = {
  name: "Abhishek Thakur",
  roles: [
    "Front End Developer",
    "React Js Developer",
    "Full-Stack Enthusiast",
    "Programmer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/abhishek00678",
  resume:
    "https://drive.google.com/file/d/1BClwGLnt7kdZpb9ht5buiZj1jmnAiXbQ/view?usp=drive_link",
  linkedin: "www.linkedin.com/in/abhishek-thakur-434a3519a",
  twitter: "https://twitter.com/Abhishe52563231",
  insta: "https://www.instagram.com/a_abhishek_thakur_004/",
  facebook: "https://www.facebook.com/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "tailwind",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
    ],
  },

  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },

      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://camo.githubusercontent.com/93b32389bf746009ca2370de7fe06c3b5146f4c99d99df65994f9ced0ba41685/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f676574706f73746d616e2f676574706f73746d616e2d69636f6e2e737667",
      },

      {
        name: "Figma",
        image:
          "https://camo.githubusercontent.com/ed93c2b000a76ceaad1503e7eb9356591b885227e82a36a005b9d3498b303ba5/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6669676d612f6669676d612d69636f6e2e737667",
      },
      {
        name: "Firebase",
        image:
          "https://webartdevelopers.com/blog/wp-content/uploads/2020/10/firebase-logo.png",
      },
      {
        name: "Rest Api ",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSiGc3joUQ0sWlPcqJI5_xyqLRe5G_5QWMppOAas6QfLA&s",
      },
      {
        name: "Vercel ",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQVWbvuvJu00fuowRbz3vETxAxzpr4QBvpMxxqT1QKiGw&s",
      },
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://images.shiksha.com/mediadata/images/1571909115phpJGfm5s.jpeg",
    school: "Shri Vaishnav Institute of Technology and  Science",
    date: "2015 - 2019",
    grade: "6.67 CGPA",
    desc: "I have completed my Bachelor's degree  in Electronics and Communication at Shri Vaishnav Institute of Technology and  Science ,Indore.",
    degree: "Bachelor of Technology - BTech, Electronics and  Communication",
  },
  {
    id: 1,
    img: "https://upload.wikimedia.org/wikipedia/commons/3/3d/Maharishi_Group_of_Schools.jpg",
    school: "Maharishi Vidya Mandir Indore",
    date: "Apr 2014 - Apr 2015",
    desc: "I completed my class 12 high school education at Maharishi Vidya Mandir Indore, where I studied PCM.",
    degree: "HSC(XII)",
  },
  {
    id: 2,
    img: "https://upload.wikimedia.org/wikipedia/commons/3/3d/Maharishi_Group_of_Schools.jpg",
    school: "Maharishi Vidya Mandir Indore",
    date: "Apr 2012 - Apr 2013",
    desc: "I completed my class 10 school education at Maharishi Vidya Mandir Indore,",
    degree: "HSC(X)",
  },
];

export const projects = [
  {
    id: 9,
    title: "Crypto App",
    date: "june 2023 - july 2023",
    description:
      "crypto app featuring a sleek UI designed with Chakra UI. It utilizes the GoinGeeCo API, React Router DOM, and Chart.js to provide users with real-time updates on cryptocurrencies. The app enables users to track market trends, view interactive charts, and explore details about different exchanges, offering a streamlined and dynamic experience for staying informed in the crypto market.",
    image: "CryptoApp.png",
    tags: [
      "React-js",
      "Chakra- Ui",
      "Eslint",
      "chart-js",
      "CoinGecko Api",
      "React-router",
      "vercel",
    ],
    category: "web app",
    github: "https://github.com/abhishek00678/crypto-app",
    webapp: "https://lnkd.in/djF7rTpk",
    member: [
      {
        name: "Abhishek Thakur",
        img: "HeroImage.jpg",
        linkedin: "www.linkedin.com/in/abhishek-thakur-434a3519a",
        github: "https://github.com/abhishek00678",
      },
    ],
  },

  {
    id: 1,
    title: "mailBox",
    date: "Oct 2023 - Oct 2023",
    description:
      "Presenting my latest Chat Application! Enjoy real-time messaging, a sleek UI, and secure communication. The app features interactive notifications, including an unread message count for quick updates. ",
    image: "mailBox.png",
    tags: [
      "React Js",
      "Firebase",
      "React Bootstrap,",
      "Express Js",
      "Redux Toolkit",
      "React Toastify ",
      "Firebase authentication",
    ],
    category: "web app",
    github: "https://github.com/abhishek00678/MailBox-Client2",
    webapp: "https://lnkd.in/dbmWmzpG",
    member: [
      {
        name: "Abhishek Thakur",
        img: "HeroImage.jpg",
        linkedin: "www.linkedin.com/in/abhishek-thakur-434a3519a",
        github: "https://github.com/abhishek00678",
      },
    ],
  },
  {
    id: 0,
    title: "Custom Form Builder",
    date: "Nov 2023 -  Nov 2023",
    description:
      " Customizable Fields: Add or remove elements according to your needs.Validation Options: Choose to include validation for the required fields.Flexibility: Select the fields you want to include—tailor it to your convenience.Tailwind CSS: Sleek and modern styling for a seamless user experience.Whether you're designing a survey, contact form, or anything in between, this form builder provides the flexibility to create exactly what you need. Build forms your way, with the elements you want!Check it out [here] (insert link) and start crafting your forms hassle-free! Your feedback is invaluable—let me know what you think. Feel free to reach out for more details.",
    image: "formBuilder.png",
    tags: ["React Js", "Css", "mui"],
    category: "web app",
    github: "https://github.com/abhishek00678/FormBuilder",
    webapp: "https://lnkd.in/dYKH5FxS",
    member: [
      {
        name: "Abhishek Thakur",
        img: "HeroImage.jpg",
        linkedin: "www.linkedin.com/in/abhishek-thakur-434a3519a",
        github: "https://github.com/abhishek00678",
      },
    ],
  },
  {
    id: 3,
    title: "Construction Website Freelance Project",
    date: "nov 2023 - nov 2023",
    description: "",
    image: "construction.png",
    tags: [
      "Bootstrap 5",
      "React Router",
      "React Toastifye",
      "React Js",
      "Email js",
      "Carousel",
    ],
    category: "web app",
    github: "https://github.com/abhishek00678/Neon-assign",
    webapp: "https://portfolio-abhi-sn1c.vercel.app/",
  },
  {
    id: 2,
    title: "Simple Expense Tracker",
    date: "july  2023 - july 2023",
    description:
      "Introducing the Expense Tracker App! Seamlessly manage finances with features like easy transaction management, a sleek dark mode for nighttime use, and personalized profiles. Download expense records as CSV files for effective tracking and ensure data security with Firebase authentication. User-friendly notifications, powered by React Toastify, enhance interaction flow. ",
    image: "expenseTracker.png",
    tags: [
      "Firebase authentication ",
      " React Toastify",
      "CSS ",
      "Redux ",
      "React",
    ],
    category: "Web app",
    github: "https://github.com/abhishek00678/expense-tracker2",
    webapp: "",
  },

  {
    id: 10,
    title: "Static Figma design",
    date: "Nov 2023 - Nov 2023",
    description:
      "Expertly developed a responsive Figma design! This project demonstrates a keen focus on creating a visually engaging and adaptable user interface across various devices. The responsive design ensures a seamless and optimal user experience on both desktop and mobile platforms.",
    image: "rayban.png",
    tags: ["Bootstrap", "html", "css"],
    category: "web app",
    github: "https://github.com/abhishek00678/expense-tracker2",
    webapp: "",
  },
];
